/* eslint-disable @next/next/no-img-element */
/* eslint-disable react/no-unescaped-entities */
// @ts-nocheck
import { useRouter } from 'next/router'
import { serverSideTranslations } from 'next-i18next/serverSideTranslations'
import { useTranslation } from 'next-i18next'
import { ListTeam, MetaData, StyledButton } from '@/components/atoms'
import { useState } from 'react'
import * as yup from "yup";
import { handleChangeSelect } from '@/utility/helper/dataMutation'
import ListTeamMain from '@/components/atoms/list/listTeamMain'
import { background_list } from '@/assets/images'
import { getSeoMetadata } from '@/utility/apiProcess/seo/server'

const mainTeam = [
  {
    image: background_list.ot1,
    name: 'Edho Zell',
    position: 'CEO & Co-Founder'
  },
  {
    image: background_list.ot2,
    name: 'Tirza Lydia',
    position: 'COO & Co-Founder'
  },
  {
    image: background_list.ot3,
    name: 'Ester Jeanette',
    position: 'CMO & Co-Founder'
  },
  {
    image: background_list.ot4,
    name: 'Messiah Faykusa',
    position: 'CTO'
  },
  // {
  //   image: 'https://i.ibb.co/Bz92qCh/DSC07852-removebg-preview-1.png',
  //   name: 'Avina Kantaatmadja ',
  //   position: 'CPO'
  // },
]
const secondaryTeamOutside = [
  {
    image: background_list.ott1,
    name: 'A. Ridha Ardhillah',
    position: 'VP Relations & Business Support',
    team: 'Marketing'
  },
  {
    image: background_list.ott2,
    name: 'Abibayu Gustri Kamadjaja',
    position: 'VP Social Bread Enterprise',
    team: 'Enterprise'
  },
  {
    image: background_list.ott3,
    name: 'Adam Firdaus',
    position: 'Senior Creator',
    team: 'Creatives'
  },
  {
    image: background_list.ott4,
    name: 'Agnes Tasia',
    position: 'Creator Manager',
    team: 'Creatives'
  },
  {
    image: background_list.ott5,
    name: 'Amanda Cinthya',
    position: 'HR Specialist',
    team: 'Operations'
  },
  {
    image: background_list.ott6,
    name: 'Anne Bening',
    position: 'Finance Manager',
    team: 'Operations'
  },
  {
    image: background_list.ott7,
    name: 'Anvirtia Priska Manangkalangi',
    position: 'Head of Instagram',
    team: 'Creatives'
  },
  {
    image: background_list.ott8,
    name: 'Bias Cahyo Widodo',
    position: 'Vice Operations',
    team: 'Operations'
  },
  {
    image: background_list.ott9,
    name: 'Citra Novariana',
    position: 'Vice CCO',
    team: 'Creatives'
  },
  {
    image: background_list.ott10,
    name: 'Clarissa Eldora Yoe',
    position: 'Senior Creator',
    team: 'Creatives'
  },
  {
    image: background_list.ott11,
    name: 'Ezra Jason Christian',
    position: 'Admin Social Media',
    team: 'Creatives'
  },
  {
    image: background_list.ott12,
    name: 'Felicia Vinna Christabella',
    position: 'KOL Project Assistant',
    team: 'Operations'
  },
  {
    image: background_list.ott13,
    name: 'Hanssen Benjamin',
    position: 'Head of Social Media Consultant',
    team: 'Marketing'
  },
  {
    image: background_list.ott14,
    name: 'Jeremiah Harvest',
    position: 'Head of Project Assistant',
    team: 'Operations'
  },
  {
    image: background_list.ott15,
    name: 'Joanne Francisca Abigail',
    position: 'Brand and Event',
    team: 'Marketing'
  },
  {
    image: background_list.ott16,
    name: 'Louise Steve',
    position: 'Creative Manager',
    team: 'Creatives'
  },
  {
    image: background_list.ott17,
    name: 'Marcelina Nathania',
    position: 'Senior Creator',
    team: 'Creatives'
  },
  {
    image: background_list.ott18,
    name: 'Monika Christly Monintja',
    position: 'Operation Lead',
    team: 'Operations'
  },
  {
    image: background_list.ott19,
    name: 'Muhammad Daffa Putra',
    position: 'Senior Creator',
    team: 'Creatives'
  },
  {
    image: background_list.ott20,
    name: 'Nabilah Rahmah',
    position: 'Social Media Assistant',
    team: 'Operations'
  },
  {
    image: background_list.ott21,
    name: 'Nathaniel Rifan',
    position: 'Senior Creator',
    team: 'Creatives'
  },
  {
    image: background_list.ott22,
    name: 'Serlie Tjahyadi',
    position: 'Finance Accounting',
    team: 'Operations'
  },
]

const LiveShoppingExperience = (props) => {
	const { t } = useTranslation('ourteam')
	const router = useRouter()
  const [category, setCategory] = useState([
    {
      label: 'All',
      isSelected: true
    },
    {
      label: 'Marketing',
      isSelected: false
    },
    {
      label: 'Operations',
      isSelected: false
    },
    {
      label: 'Creatives',
      isSelected: false
    },
    {
      label: 'Enterprise',
      isSelected: false
    }
  ])
  const [secondaryTeam, setSecondaryTeam] = useState(secondaryTeamOutside)

  const handleFilterCategory = (label:string) => {
    const clone_category = _.cloneDeep(category)
    const clone_secondaryTeam = _.cloneDeep(secondaryTeamOutside)
    clone_category.forEach((item) => {
      if(item.label === label) {
        item.isSelected = true
      } else {
        item.isSelected = false
      }
    })
    setCategory(clone_category)
    if(label === 'All') {
      setSecondaryTeam(clone_secondaryTeam)
    } else {
      const filteredTeam = clone_secondaryTeam.filter((item) => item.team === label)
      setSecondaryTeam(filteredTeam)
    }
  }
 
	return (
		<div className='tw-bg-gradient-to-r tw-from-dark-green tw-to-light-green tw-w-full'>
      <MetaData title={props.seoMetadata.title} ogImage="https://i.ibb.co/bzC5z1g/socialbreadlogo.jpg" ogTitle={props.seoMetadata.title} keywords={props.seoMetadata.keywords} ogDescription={props.seoMetadata.description} />
			<div className='tw-newsroom-banner' id='newsroom-banner'>
				<div className='tw-m-auto md:tw-py-16 tw-py-8 md:tw-px-2 tw-px-4 tw-max-w-6xl tw-mx-auto tw-grid tw-gap-2'>
					<h2 className='tw-text-white md:tw-text-5xl tw-text-2xl tw-font-semibold tw-mb-5 md:tw-text-left tw-text-center'>
            {t('ourteam.title')}
          </h2>
          <span className='tw-text-white tw-text-sm md:tw-text-justify tw-flex tw-text-center'>
            {t('ourteam.desc')}
          </span>
          
				</div>
			</div> 
			<div className=' tw-bg-[#F1F1F1] md:tw-rounded-[40px] tw-rounded-[20px] tw-overflow-hidden'>
        <div className='tw-max-w-6xl tw-mx-auto tw-my-8 tw-mb-20 md:tw-px-10 tw-px-5 tw-text-justify'>
          <div className='tw-mb-32'>
            <h1 className='md:tw-text-5xl tw-text-2xl tw-font-semibold tw-mb-5 tw-mt-10 tw-text-transparent tw-bg-clip-text tw-bg-gradient-to-r tw-from-dark-green tw-from-40% tw-to-light-green tw-to-60% tw-text-left md:tw-px-5 tw-w-fit tw-pb-1'>{t('ourteam.management')}</h1>
            <p className='tw-text-left md:tw-px-5 tw-mb-5'>
              {t('ourteam.management_desc')}
            </p>
            <ListTeamMain data={mainTeam} />
            {/* <ListTeam data={mainTeam} isCentered={true}/> */}
          </div>
          <div className='tw-mb-24'>
            <h1 className='md:tw-text-5xl tw-text-2xl tw-font-semibold tw-mb-5 tw-mt-10 tw-text-transparent tw-bg-clip-text tw-bg-gradient-to-r tw-from-dark-green tw-from-40% tw-to-light-green tw-to-60% tw-text-left md:tw-px-5 tw-w-fit tw-pb-1'>{t('ourteam.people')}</h1>
            <p className='tw-text-left md:tw-px-5 tw-mb-5'>
              {t('ourteam.people_desc')}
            </p>
            <div className='tw-flex tw-flex-row tw-gap-2 tw-flex-wrap tw-my-10 md:tw-px-5'>
              {category.map((item, index) => {
                return (
                  <StyledButton
                    key={`cat-${index}`}
                    title={item.label}
                    className={`${item.isSelected ? 'btn-dark-to-light-green-gradient tw-text-white' : 'tw-bg-transparent tw-text-dark-green tw-border-dark-green tw-border-[1px]' }  tw-font-semibold md:tw-text-md tw-text-xs tw-items-center md:tw-px-4  tw-px-3 md:tw-py-2 tw-py-1 tw-rounded-full md:tw-flex `}
                    onClick={() => handleFilterCategory(item.label)}
                  />
                )
              })}
            </div>
            <ListTeam data={secondaryTeam} />
          </div>
          <div className='tw-flex md:tw-flex-row tw-flex-col tw-items-center tw-justify-center md:tw-p-6 tw-gap-5 lg:tw-justify-between'>
            <div className='md:tw-mr-12 tw-block'>
              <h1 className='md:tw-text-5xl tw-text-xl md:tw-text-left tw-text-center tw-font-semibold tw-text-transparent tw-bg-clip-text tw-bg-gradient-to-r tw-from-dark-green tw-from-30% tw-to-light-green tw-to-70%'>
                {t('ourteam.bep')}
              </h1>
            </div>
            <div className='md:tw-w-[500px] tw-flex tw-justify-end'>
              <StyledButton
                title={t('ourteam.job')}
                className='tw-text-white btn-dark-to-light-green-gradient tw-font-semibold md:tw-text-[14px] tw-text-xs tw-items-center tw-border-2 md:tw-py-5 md:tw-px-5 tw-px-3 tw-py-3 tw-rounded-full tw-justify-center md:tw-flex'
                onClick={() => console.log('PUSH')}
              />
            </div>
				  </div>
        </div>
			</div>
		</div>
	)
}

export default LiveShoppingExperience

export async function getStaticProps() {
  const locale = 'id'
  let seoMetadata = { data: { result: {} } }
  try {
    seoMetadata = await getSeoMetadata({category_slug: 'pages', names: 'our-team'})
  } catch (err) {
    console.error('[getStaticProps] getSeoMetadata failed at build time, falling back to {}', err)
  }

  return {
		props: {
      seoMetadata: seoMetadata.data.result || {},
			...(await serverSideTranslations(locale, ['footer', 'navbar', 'privacy-policy'])),
		},
	}
}
